import { Component, OnInit , Output ,EventEmitter, ViewChild, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Anagrafica } from 'src/app/common/models/anagrafica';
import { OperationsService } from 'src/app/core/services/operations.service';
import { Observable, Subject } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { SearchAnagraficheResponse } from 'src/app/common/models/dto/search-anagrafiche-response';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { Input } from '@angular/core';
import { Parte } from 'src/app/common/models/parte';
import { CreazionePraticaStoreService } from '../../../services/creazione-pratica-store.service';
import { Controparte } from 'src/app/common/models/controparte';
import { AssociazioneControparteFormComponent } from '../associazione-controparte-form/associazione-controparte-form.component';
import { isControparteAssociated, isParteAssociable } from '../../../utils/parti-utils';
import { takeUntil } from 'rxjs/operators';
import { refreshContropartePrimaria } from '../../../utils/controparti-utils';

@Component({
  selector: 'list-parti',
  templateUrl: './list-parti.component.html',
  styleUrls: ['./list-parti.component.css']
})
export class ListPartiComponent<T extends Anagrafica>  implements OnInit,OnChanges,OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  msgEmpty: string;
  labelButton = 'Associa'
  disabled = false;
  @Input() totali: number;
  @Input() labelComponent:string;
  @Input() action:string;
  @Input() optionsList: { isAssociable: boolean, isControparte: boolean, hasDetailsAnagrafica: boolean, anagrafica: T, categoria?: string, tipoSoggetto?: string  }[] = [];
  @Output() onReturn: EventEmitter<Controparte> = new EventEmitter<Controparte>();
  @Output() actionEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() emitParte: EventEmitter<Parte> = new EventEmitter<Parte>();
  @Output() requestMore: EventEmitter<void> = new EventEmitter<void>();
  controparti: Controparte[] = [];
  activeIndex:number;
  associationParte: boolean;
  editingParte: boolean;
  componentDestroyed$: Subject<void> = new Subject<void>();


  constructor(private operations: OperationsService, private creazionePraticaStoreService: CreazionePraticaStoreService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.action !== this.labelComponent){
      this.associationParte = false;
      this.activeIndex = undefined;
    }
  }

  ngOnInit() {
    this.creazionePraticaStoreService.controparti$.pipe(takeUntil(this.componentDestroyed$)).subscribe(controparti => {
      this.controparti = [];
      if(controparti){
        this.controparti = controparti;
        this.optionsList.forEach(element => {
          isControparteAssociated(element , this.controparti)
        });

      }
    })
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

  openDetail(option: {isAssociable:boolean,isControparte:boolean,  hasDetailsAnagrafica: boolean, anagrafica: any }, indice: number) {
    this.actionEmitter.emit(this.labelComponent);
    this.associationParte = false;
    if(this.activeIndex === indice){
      this.activeIndex = undefined;
    } else {
      if (!option.hasDetailsAnagrafica && option.anagrafica.id && !option.anagrafica.id.startsWith('TEMP')) {
        this.getAnagrafica(option.anagrafica).subscribe(response => this.refreshElementInArray(indice, response));
      }
      this.activeIndex = indice;
      if(!option.isAssociable){
        this.editingParte = true;
      } else {
        this.editingParte = false;
      }
    }
  }

  associa(option: {isAssociable:boolean,isControparte:boolean, hasDetailsAnagrafica: boolean, anagrafica: Parte }, indice: number) {
    this.actionEmitter.emit(this.labelComponent);
    this.activeIndex = indice;
    this.associationParte = true;
    this.editingParte = false;
  }

  retrieveParte(parte: Parte , option: {isAssociable:boolean,isControparte:boolean, hasDetailsAnagrafica: boolean, anagrafica: Parte }){
    this.activeIndex = undefined;
    this.emitParte.emit(parte);
    if(parte){
      let isAssociable = isParteAssociable(parte, this.editingParte);
      option.isAssociable = isAssociable;
      option.anagrafica = parte;
    }
  }

  retrieveControparte(controparte: Controparte){
    // this.controparti.push(controparte);
    this.onReturn.emit(controparte);
    // let contropartiFiltred = refreshContropartePrimaria(this.controparti,controparte);
    // this.creazionePraticaStoreService.setControparti(contropartiFiltred);
    // this.creazionePraticaStoreService.save();
    this.activeIndex = undefined;
    this.editingParte = false;
    this.associationParte = false;
  }

  private getAnagrafica(option: T): Observable<T> {
    return this.operations.getAnagrafica( ServicePathsSettings.URL_GET_PARTE , option.id, true);
  }

  private refreshElementInArray(indice: number, element: T): { hasDetailsAnagrafica: boolean, anagrafica: T } {
    this.optionsList[indice].isAssociable = isParteAssociable(element,this.editingParte);
    this.optionsList[indice].hasDetailsAnagrafica = true;
    this.optionsList[indice].anagrafica = element;
    return this.optionsList[indice];
  }

}
